<template>
  <div>
    <ScaleBox>
      <div class="mr-visual">
        <v-header-box/>
        <div class="mr-visual-container">
          <!-- 数据卡片区域 -->
          <section class="card-area">
            <el-card class="data-card with-trend" style="margin-right: 100px;">
              <span class="card-value">{{screenData.prevJson.energy}}</span>
              <span class="card-label" style="color:#1E90FF">{{screenData.prevJson.energyLabel}}</span>
            </el-card>
            <el-card class="data-card with-trend" style="margin-right: 100px;">
              <!--<span style="color:red;font-size:22px;">18.14<i style="font-size:22px;" class="el-icon-top"></i></span>-->
              <span class="card-value">{{screenData.thisJson.energy}}</span>
              <span class="card-label" style="color:green">{{screenData.thisJson.energyLabel}}</span>
            </el-card>
            <el-card class="data-card with-trend" style="margin-right: 100px;">
              <span class="card-value">{{screenData.prevJson.money}}</span>
              <span class="card-label" style="color:#1E90FF">{{screenData.prevJson.moneyLabel}}</span>
            </el-card>
            <el-card class="data-card with-trend">
              <!--<span style="color:green;font-size:22px;">36.2%<i style="font-size:22px;" class="el-icon-bottom"></i></span>-->
              <span class="card-value">{{screenData.thisJson.money}}</span>
              <span class="card-label" style="color:green">{{screenData.thisJson.moneyLabel}}</span>
            </el-card>
          </section>
          <div style="height:10px;">&nbsp;</div>
          <!-- 主体内容区（左侧+图表） -->
          <section class="main-area">
            <!-- 左侧同比环比数据 -->
            <aside class="left-aside">
              <el-card class="data-card" style="text-align:left;padding-top:10px;padding-bottom:23px;height:200px;">
                <div class="trend-item">
                  <span class="trend-title">年度同比<span style="margin-left:20px;" :class=screenData.yearTB.energyColor>{{screenData.yearTB.energyPercent}}&nbsp;<i style="font-size:22px;" :class=screenData.yearTB.energyClass></i></span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.yearTB.thisLabel}}<span class="trend-value">{{screenData.yearTB.thisEnergy}}</span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.yearTB.prevLabel}}<span class="trend-value">{{screenData.yearTB.prevEnergy}}</span></span>
                </div>
              </el-card>

              <el-card class="data-card" style="margin-top:30px;text-align:left;padding-top:10px;padding-bottom:23px;height:200px;">
                <div class="trend-item">
                  <span class="trend-title">本月环比ABC<span style="margin-left:20px;" :class=screenData.monthHB.energyColor>{{screenData.monthHB.energyPercent}}&nbsp;<i style="font-size:22px;" :class=screenData.monthHB.energyClass></i></span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.monthHB.thisLabel}}<span class="trend-value">{{screenData.monthHB.thisEnergy}}</span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.monthHB.prevLabel}}<span class="trend-value">{{screenData.monthHB.prevEnergy}}</span></span>
                </div>
              </el-card>
              
              <el-card class="data-card" style="margin-top:30px;text-align:left;padding-top:10px;padding-bottom:10px;height:200px;">
                <div class="trend-item">
                  <span class="trend-title">近日环比ABC<span style="margin-left:20px;" :class=screenData.dayHB.energyColor>{{screenData.dayHB.energyPercent}}&nbsp;<i style="font-size:22px;" :class=screenData.dayHB.energyClass></i></span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.dayHB.thisLabel}}<span class="trend-value">{{screenData.dayHB.thisEnergy}}</span></span>
                </div>
                <div class="trend-item">
                  <span class="trend-label">{{screenData.dayHB.prevLabel}}<span class="trend-value">{{screenData.dayHB.prevEnergy}}</span></span>
                </div>
              </el-card>
            </aside>

            <!-- 图表区域 -->
            <div class="chart-area">
              <!-- 日用电量 -->
              <div class="chart-item">
                <div class="chart-header">
                  ABC库日用电量 {{dayOptionData.total==0?'kW·h':'('+dayOptionData.total+' kW·h)'}}
                  <div class="chart-date">
                    <i style="font-size:24px;vertical-align:middle;margin-right:5px;" class="el-icon-arrow-left" @click="changeDate(-1)"></i>
                    <el-date-picker v-model="dayFilter" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" @change="freezerEnergyHours"/>
                    <i style="font-size:24px;vertical-align:middle;margin-left:5px;" class="el-icon-arrow-right" @click="changeDate(1)"></i>
                  </div>
                </div>
                <ECharts :options="dayUsageOption" class="chart" :height="echartHeight" />
              </div>

              <!-- 能耗分项 -->
              <div class="chart-item">
                <div class="chart-header">
                  <div class="chart-header">冷库能流图<span style="color:greenyellow;font-size:20px;" @click="showFlow">（看大图）</span></div>
                  <div class="chart-filter">
                    <el-date-picker v-model="startEnergy" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="开始日期" @change="freezerEnergyMeter"/>
                    ~
                    <el-date-picker v-model="endEnergy" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="截止日期" @change="freezerEnergyMeter"/>
                  </div>
                </div>
                <ECharts :options="energyOption" class="chart" :height="echartHeight" />
              </div>

              <!-- 月用电量 -->
              <div class="chart-item">
                <div class="chart-header">
                  ABC库月用电量 {{monthOptionData.total==0?'kW·h':'('+monthOptionData.total+' kW·h)'}}
                  <div class="chart-date">
                    <i style="font-size:24px;vertical-align:middle;margin-right:5px;" class="el-icon-arrow-left" @click="changeMonth(-1)"></i>
                    <el-date-picker v-model="monthFilter" value-format="yyyy-MM" format="yyyy-MM" placeholder="选择月份" @change="freezerEnergyMonth"/>
                    <i style="font-size:24px;vertical-align:middle;margin-left:5px;" class="el-icon-arrow-right" @click="changeMonth(1)"></i>
                  </div>
                </div>
                <ECharts :options="monthUsageOption" class="chart" :height="echartHeight" />
              </div>

              <!-- 年度能耗对比 -->
              <div class="chart-item">
                <div class="chart-header">
                  ABCDE库年度能耗对比 kW·h
                  <div class="chart-year">
                    <el-select v-model="yearStart" placeholder="2024" style="width:100px;margin-right:10px;" @change="freezerEnergyYear">
                      <el-option label="2024" value="2024"/>
                      <el-option label="2025" value="2025"/>
                    </el-select>
                    <el-select v-model="yearEnd" placeholder="2025" style="width:100px;margin-left:10px;" @change="freezerEnergyYear">
                      <el-option label="2024" value="2024"/>
                      <el-option label="2025" value="2025"/>
                      <el-option label="2026" value="2026"/>
                    </el-select>
                  </div>
                </div>
                <ECharts :options="yearUsageOption" class="chart" :height="echartHeight" />
              </div>
            </div>
          </section>
        </div>
        <div class="mr-visual-footer">
          <v-footer/>
        </div>
      </div>
    </ScaleBox>
    <Flow :project="projectCode" :sankeVisible="sankeVisible" @handleClose="handleClose"/>
  </div>
</template>

<script lang="js">
import { mapState } from "vuex";
import VHeaderBox from "./components/v-header-box.vue";
import VFooter from "./components/v-footer.vue";
import Flow from "./components/flow.vue";
import ScaleBox from "@/components/view/scaleBox.vue";
import ECharts from '@/components/view/ECharts.vue';
import { DateToShort, DateToYYYYMM } from "@/utils/util/util";

export default {
  name: 'visual',
  components: {
    VHeaderBox,
    VFooter,
    ScaleBox,
    ECharts,
    Flow
  },
  data() {
    return {
      projectCode: null,
      sankeVisible: false,
      dayUsageOption: {},
      energyOption: {},
      monthUsageOption: {},
      yearUsageOption: {},
      echartHeight: "280px",
      dayFilter: "2025-11-11",
      monthFilter: '2025-11',
      startEnergy: '2025-11-01',
      endEnergy: '2025-11-15',
      yearStart: '2024',
      yearEnd: '2025',
      dayOptionData: {
        "series": [],
        "total": 0
      },
      energyOptionData: {
        "data": [],
        "links": [],
      },
      monthOptionData: {
        "xAxis": [],
        "series": [],
        "total": 0
      },
      yearOptionData: {
        "series": []
      },
      screenData: {
        "thisJson": {
          "year": "--",
          "energy": "--",
          "money": "--",
          "energyLabel":"--",
          "moneyLabel":"--",
        },
        "prevJson": {
          "year": "--",
          "energy": "--",
          "money": "--",
          "energyLabel":"--",
          "moneyLabel":"--",
        },
        "yearTB": {
          "thisLabel": "--",
          "prevLabel": "--",
          "thisEnergy": "--",
          "prevEnergy":"--",
          "energyPercent":"--",
          "energyClass":"--",
          "energyColor":"",
        },
        "monthHB": {
          "thisLabel": "--",
          "prevLabel": "--",
          "thisEnergy": "--",
          "prevEnergy":"--",
          "energyPercent":"--",
          "energyClass":"--",
          "energyColor":"",
        },
        "dayHB": {
          "thisLabel": "--",
          "prevLabel": "--",
          "thisEnergy": "--",
          "prevEnergy":"--",
          "energyPercent":"--",
          "energyClass":"--",
          "energyColor":"",
        }
      },
    }
  },
  computed: {
    ...mapState(["projectCurrentRowData"])
  },
  mounted() {
    const currentDate = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(currentDate.getDate() - 30);
    const currentData = this.projectCurrentRowData || {};
    this.projectCode = currentData.projectCode;
    this.echartHeight = ((document.documentElement.clientHeight-190)*0.4)+"px";
    this.dayFilter=DateToShort(currentDate);
    this.startEnergy=DateToShort(fifteenDaysAgo);
    this.endEnergy=DateToShort(currentDate);
    this.monthFilter = DateToYYYYMM(currentDate);
    this.freezerEnergy();
    this.initDayOption();
    this.initEnergyOption();
    this.initMonthOption();
    this.initYearOption();
    this.freezerEnergyHours();
    this.freezerEnergyMonth();
    this.freezerEnergyYear();
    this.freezerEnergyMeter();
  },
  methods: {
    freezerEnergy() {
      const that=this;
      var params={
          project: that.projectCode,
      }
      that.request.freezerEnergy(params).then((res) => {
        if (res.code==0) {
          this.screenData = res.data;
        } 
      });
    },
    showFlow() {
      this.sankeVisible=true;
    },
    handleClose() {
      this.sankeVisible=false;
    },
    changeMonth(month) {
      const newDate = new Date(this.monthFilter+'-01');
      newDate.setMonth(newDate.getMonth() + month);
      this.monthFilter = DateToYYYYMM(newDate);
      this.freezerEnergyMonth();
    },
    changeDate(days) {
      const newDate = new Date(this.dayFilter);
      newDate.setDate(newDate.getDate() + days);
      this.dayFilter = DateToShort(newDate);
      this.freezerEnergyHours();
    },
    freezerEnergyHours() {
      const that=this;
      var params={
          project: that.projectCode,
          dateStr: that.dayFilter,
      }
      that.request.freezerEnergyHours(params).then((res) => {
        if (res.code==0) {
          that.dayOptionData = res.data;
          that.initDayOption();
          that.$forceUpdate();
        } 
      });
    },
    freezerEnergyMonth() {
      const that=this;
      var params={
          project: that.projectCode,
          dateStr: that.monthFilter,
      }
      that.request.freezerEnergyMonth(params).then((res) => {
        if (res.code==0) {
          that.monthOptionData=res.data;
          that.initMonthOption();
          that.$forceUpdate();
        } 
      });
    },
    freezerEnergyYear() {
      const that=this;
      var params={
          project: that.projectCode,
          yearStart: that.yearStart,
          yearEnd: that.yearEnd,
      }
      that.request.freezerEnergyYear(params).then((res) => {
        if (res.code==0) {
          that.yearOptionData = res.data;
          that.initYearOption();
          that.$forceUpdate();
        } 
      });
    },
    freezerEnergyMeter() {
      const that=this;
      var params={
          project: that.projectCode,
          dateStart: that.startEnergy,
          dateEnd: that.endEnergy,
      }
      that.request.freezerEnergyMeter(params).then((res) => {
        if (res.code==0) {
          that.energyOptionData = res.data;
          that.initEnergyOption();
          that.$forceUpdate();
        } 
      });
    },
    initDayOption() {
      this.dayUsageOption={
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' },
        },
        xAxis: { 
          type: 'category',
          data: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'], 
          axisLabel: { color: '#ffffff' },
          boundaryGap: true
        },
        yAxis: { 
          type: 'value', 
          axisLabel: { color: '#ffffff' },
          splitLine: {
            show: true, 
            lineStyle: {
              color: '#25253F', 
              width: 1,  
              type: 'solid' 
            }
          }
        },
        series: this.dayOptionData.series
      };
    },
    initEnergyOption() {
      this.energyOption={
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            nodeAlign: "left",
            data: this.energyOptionData.data,
            links: this.energyOptionData.links,
            lineStyle: {
              color: "source",
              curveness: 0.5,
            },
            itemStyle: {
                borderWidth: 0.5,
                borderColor: '#ffffff'
            },
            nodeGap: 30,
            label: {
                show: true, 
                color: 'lightGray',
                fontSize: 13,
                formatter: function(params) {
                  var label=params.name+'\r\n'+params.value+" kW·h";
                  return label;
                }
            },
            emphasis: {
                focus: 'adjacency'
            }
          },
        ],
      }
    },
    initMonthOption() {
      this.monthUsageOption={
         color: ['#ff3333', '#ffcc00', '#999999', '#66ccff'],
         tooltip: { trigger: 'axis' },
         legend: {
          show: true,
          textStyle: { color: '#ffffff' }
         },
         grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
         xAxis: { 
          type: 'category', 
          data: this.monthOptionData.xAxis, 
          axisLabel: { color: '#ffffff' },
          boundaryGap: true
         },
         yAxis: { 
          type: 'value', 
          axisLabel: { color: '#ffffff' },
          splitLine: {
            show: true, 
            lineStyle: {
              color: '#25253F', 
              width: 1,  
              type: 'solid' 
            }
          }
        },
        series: this.monthOptionData.series
      };
    },
    initYearOption() {
      this.yearUsageOption={
        color: ['#66ccff', '#cc99ff'],
        tooltip: { trigger: 'axis' },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' }
        },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLabel: { color: '#ffffff' }
        },
        yAxis: { 
          type: 'value', 
          axisLabel: { color: '#ffffff' },
          splitLine: {
            show: false
          },
        },
        series: this.yearOptionData.series
      };
    },
  }
}
</script>
<style scoped lang="scss">

.mr-visual {
  height: 100%;
  background-color: rgba(0, 0, 0, 1);
  color:white;
  overflow: hidden;
  position: relative;

  .mr-visual-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .mr-visual-container {
    height: 60%;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .mr-visual-footer {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
  }
}

.card-area {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.data-card {
  flex: 1;
  margin-right: 0px;
  background-color: rgba(31, 51, 89, 0.4);
  border: none;
  border-radius: 4px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: white;
  height: 120px;
}

.data-card:last-child {
  margin-right: 0;
}

.card-value {
  display: block;
  font-size: 36px;
  font-weight: bold;
  margin-top: 0px;
}

.card-label {
  display: block;
  font-size: 18px;
  font-weight: bold;
  margin-top: 5px;
}

.with-trend {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.trend-down {
  margin-right: 4px;
  color: #22c55e;
  font-size: 18px;
}

.trend-up {
  margin-right: 4px;
  color: red;
  font-size: 18px;
}

.main-area {
  display: flex;
  margin-bottom: 20px;
}

.left-aside {
  width: 350px;
  margin-right: 20px;
}

.trend.down {
  margin-right: 4px;
  color: #22c55e;
  font-size: 18px;
}

.trend.up {
  margin-right: 4px;
  color: red;
  font-size: 18px;
}

.trend-item {
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.trend-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.trend-title {
  font-size: 18px;
  font-weight:bold;
}

.trend-label {
  font-size: 16px;
  color: lightgray;
}

.trend-value {
  margin-left: 20px;
  font-size: 18px;
  color: lightgray;
}

.chart-area {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
}

.chart-item {
  flex: 1 1 calc(50% - 10px);
  background-color: rgba(31, 51, 89, 0.4);
  color: white;
  border-radius: 4px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-top: 5px;
  box-sizing: border-box;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 5px;
}

.chart-date, .chart-filter, .chart-year {
  font-size: 12px;
  font-weight: normal;
  opacity: 0.8;
}

.chart {
  width: 100%;
  height: 100px;
  background-color: rgba(31, 51, 89, 0);
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 140px;
  text-align: center;
}

::v-deep .el-input__inner {
  background-color: rgba(31, 51, 89, 0.4) !important; 
  color: #ffffff !important;
  border-color: rgba(31, 51, 89, 1);
}

</style>
